import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollbarService {
  private valueSubject = new BehaviorSubject<{ id: string; value: number }>({ id: '', value: 0 });
  public value$ = this.valueSubject.asObservable();

  setValue(id: string, value: number): void {
    this.valueSubject.next({ id, value });
  }
}
